export const CART_API = {
  ADD_TO_CART_WITH_CUSTOM_PRICE_URL: `user/addToCart`,
  GET_USER_CART: `v2/users/cart`,
  SET_USER_CART: `users/cart`,
  DELETE_USER_CART_PRODUCT: productId =>
    `user/removeFromCart/${productId}/unimportant`,
  GET_PRODUCT_BY_PRODUCTIDS: "product/getProductsByProdIds",
  MAKE_ORDER_BY_CART: `order/makeOrderByCart`,
};
